import { render, staticRenderFns } from "./table_parameter_detail.vue?vue&type=template&id=0d1bb7a3"
import script from "./table_parameter_detail.vue?vue&type=script&lang=js"
export * from "./table_parameter_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports